export default "__VITE_ASSET__50f227c4__"